import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const Icon: React.FC<SvgProps> = (props) => {
  const { viewBox, width, height, color, onClick } = props

  return (
    <Svg
      viewBox={viewBox || '0 0 24 24'}
      width={width || '24'}
      height={height || '24'}
      fill="none"
      color={color}
      onClick={onClick}
    >
      <path d="M18 6L6 18" stroke={color || 'white'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 6L18 18" stroke={color || 'white'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  )
}

export default Icon
